import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const ImageSection = ({ image, heading }) => {
  return (
    <Container className="mt-4 mt-md-0">
      <Row>
        <Col>
          <img style={{boxShadow: '0px 4px 50px 0px #0000001A'}} className="section-image" src={image} alt={heading} />
        </Col>
      </Row>
    </Container>
  );
};

export default ImageSection;
